import {
  SEGMENT_ROOT_NODE_ID,
  SEGMENT_TRY_AGAIN_NODE_ID,
  SEGMENT_VALIDATION_NODE_ID,
} from "./constants";

export const getDocValidationSegment = (): Flow => {
  return {
    nodes: [
      {
        id: SEGMENT_ROOT_NODE_ID,
        data: {
          outgoingMessage:
            "¿Cuál es el país de tu documento de identificación?",
          order: 1,
          incomingMessage: "Sí",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "multiple",
      },
      {
        id: "1_CO",
        data: {
          order: 1,
          incomingMessage: "Colombia",
          outgoingMessage:
            "¿Cuál es el tipo de tu documento de identificación?",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "multiple",
      },
      {
        id: "2_MX",
        data: {
          order: 2,
          incomingMessage: "México",
          outgoingMessage:
            "¿Cuál es el tipo de tu documento de identificación?",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "multiple",
      },
      {
        id: "3_BR",
        data: {
          order: 3,
          incomingMessage: "Brasil",
          outgoingMessage:
            "¿Cuál es el tipo de tu documento de identificación?",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "multiple",
      },
      {
        id: "4_CL",
        data: {
          order: 4,
          incomingMessage: "Chile",
          outgoingMessage:
            "¿Cuál es el tipo de tu documento de identificación?",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "multiple",
      },
      // asks for front side image of the document
      {
        id: "1_CO_1_national_id",
        data: {
          order: 1,
          incomingMessage: "Cédula de ciudadanía",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse la cédula de ciudadanía.",
          variableType: "image",
          file: "CONationalFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "1_CO_2_foreign_id",
        data: {
          order: 2,
          incomingMessage: "Cédula de extranjería",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse la cédula de extranjería.",
          variableType: "image",
          file: "COForeignFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "1_CO_3_pep",
        data: {
          order: 3,
          incomingMessage: "PEP",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el permiso especial de permanencia.",
          variableType: "image",
          file: "COPep",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "1_CO_4_passport",
        data: {
          order: 4,
          incomingMessage: "Pasaporte",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el pasaporte.",
          variableType: "image",
          file: "passport",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "2_MX_1_national_id",
        data: {
          order: 1,
          incomingMessage: "INE/IFE",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el INE/IFE.",
          variableType: "image",
          file: "MXNationalFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "2_MX_2_foreign_id",
        data: {
          order: 2,
          incomingMessage: "FM3",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el FM3.",
          variableType: "image",
          file: "MXForeignFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "2_MX_3_passport",
        data: {
          order: 3,
          incomingMessage: "Pasaporte",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el pasaporte.",
          variableType: "image",
          file: "passport",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "3_BR_1_national_id",
        data: {
          order: 1,
          incomingMessage: "RG",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el RG.",
          variableType: "image",
          file: "BRNationalFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "3_BR_2_drivers_license",
        data: {
          order: 2,
          incomingMessage: "CNH",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el CNH.",
          variableType: "image",
          file: "BRDriversLicenseFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "3_BR_3_passport",
        data: {
          order: 3,
          incomingMessage: "Pasaporte",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el pasaporte.",
          variableType: "image",
          file: "passport",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "4_CL_1_national_id",
        data: {
          order: 1,
          incomingMessage: "Cédula de identidad",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse la cédula de identidad.",
          variableType: "image",
          file: "CLNationalFront",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "4_CL_2_passport",
        data: {
          order: 2,
          incomingMessage: "Pasaporte",
          outgoingMessage:
            "Envía una foto *delantera* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el pasaporte.",
          variableType: "image",
          file: "passport",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      // asks for back side image of the document
      {
        id: "1_CO_1_national_id_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse la cédula de ciudadanía.",
          variableType: "image",
          file: "CONationalBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "1_CO_2_foreign_id_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse la cédula de extranjería.",
          variableType: "image",
          file: "COForeignBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "2_MX_1_national_id_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el INE/IFE.",
          variableType: "image",
          file: "MXNationalBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "2_MX_2_foreign_id_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el FM3.",
          variableType: "image",
          file: "MXForeignBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "3_BR_1_national_id_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el RG.",
          variableType: "image",
          file: "BRNationalBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "3_BR_2_drivers_license_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse el CNH.",
          variableType: "image",
          file: "BRDriversLicenseBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: "4_CL_1_national_id_back",
        data: {
          outgoingMessage:
            "Envía una foto del *reverso* de tu documento. Comprueba que toda la información sea fácil de leer. En la imagen puedes ver un ejemplo de cómo debería visualizarse la cédula de identidad.",
          variableType: "image",
          file: "CLNationalBack",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      // asks validation status to the user.
      {
        id: SEGMENT_VALIDATION_NODE_ID,
        data: {
          outgoingMessage: "Estamos validando tu información ⏳",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
          conditionPaths: {
            success: "", // continue the block connected to the success edge.
            failure: SEGMENT_TRY_AGAIN_NODE_ID,
          },
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: SEGMENT_TRY_AGAIN_NODE_ID,
        data: {
          outgoingMessage:
            "El documento no pudo ser validado. Recuerda que toda la información debe estar legible y nítida. ¿Quieres reintentar?\n\n1) Sí\n2) No",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
    ],
    edges: [
      // Country multiple options
      {
        id: "1-1_CO",
        source: SEGMENT_ROOT_NODE_ID,
        target: "1_CO",
        data: {},
      },
      {
        id: "1-2_MX",
        source: SEGMENT_ROOT_NODE_ID,
        target: "2_MX",
        data: {},
      },
      {
        id: "1-3_BR",
        source: SEGMENT_ROOT_NODE_ID,
        target: "3_BR",
        data: {},
      },
      {
        id: "1-4_CL",
        source: SEGMENT_ROOT_NODE_ID,
        target: "4_CL",
        data: {},
      },
      // CO --> document type multiple options
      {
        id: "1_CO-1_CO_1_national_id",
        source: "1_CO",
        target: "1_CO_1_national_id",
        data: {},
      },
      {
        id: "1_CO-1_CO_2_foreign_id",
        source: "1_CO",
        target: "1_CO_2_foreign_id",
        data: {},
      },
      {
        id: "1_CO-1_CO_3_pep",
        source: "1_CO",
        target: "1_CO_3_pep",
        data: {},
      },
      {
        id: "1_CO-1_CO_4_passport",
        source: "1_CO",
        target: "1_CO_4_passport",
        data: {},
      },
      // MX --> document type multiple options
      {
        id: "2_MX-2_MX_1_national_id",
        source: "2_MX",
        target: "2_MX_1_national_id",
        data: {},
      },
      {
        id: "2_MX-2_MX_2_foreign_id",
        source: "2_MX",
        target: "2_MX_2_foreign_id",
        data: {},
      },
      {
        id: "2_MX-2_MX_3_passport",
        source: "2_MX",
        target: "2_MX_3_passport",
        data: {},
      },
      // BR --> document type multiple options
      {
        id: "3_BR-3_BR_1_national_id",
        source: "3_BR",
        target: "3_BR_1_national_id",
        data: {},
      },
      {
        id: "3_BR-3_BR_2_drivers_license",
        source: "3_BR",
        target: "3_BR_2_drivers_license",
        data: {},
      },
      {
        id: "3_BR-3_BR_3_passport",
        source: "3_BR",
        target: "3_BR_3_passport",
        data: {},
      },
      // CL --> document type multiple options
      {
        id: "4_CL-4_CL_1_national_id",
        source: "4_CL",
        target: "4_CL_1_national_id",
        data: {},
      },
      {
        id: "4_CL-4_CL_2_passport",
        source: "4_CL",
        target: "4_CL_2_passport",
        data: {},
      },
      // CO --> document front side image
      {
        id: "1_CO_1_national_id-1_CO_1_national_id_back",
        source: "1_CO_1_national_id",
        target: "1_CO_1_national_id_back",
        data: {},
      },
      {
        id: "1_CO_2_foreign_id-1_CO_2_foreign_id_back",
        source: "1_CO_2_foreign_id",
        target: "1_CO_2_foreign_id_back",
        data: {},
      },
      // MX --> document front side image
      {
        id: "2_MX_1_national_id-2_MX_1_national_id_back",
        source: "2_MX_1_national_id",
        target: "2_MX_1_national_id_back",
        data: {},
      },
      {
        id: "2_MX_2_foreign_id-2_MX_2_foreign_id_back",
        source: "2_MX_2_foreign_id",
        target: "2_MX_2_foreign_id_back",
        data: {},
      },
      // BR --> document front side image
      {
        id: "3_BR_1_national_id-3_BR_1_national_id_back",
        source: "3_BR_1_national_id",
        target: "3_BR_1_national_id_back",
        data: {},
      },
      {
        id: "3_BR_2_drivers_license-3_BR_2_drivers_license_back",
        source: "3_BR_2_drivers_license",
        target: "3_BR_2_drivers_license_back",
        data: {},
      },
      // CL --> document front side image
      {
        id: "4_CL_1_national_id-4_CL_1_national_id_back",
        source: "4_CL_1_national_id",
        target: "4_CL_1_national_id_back",
        data: {},
      },
      // CO --> validation block
      {
        id: "1_CO_1_national_id_back-validation_block",
        source: "1_CO_1_national_id_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "1_CO_2_foreign_id_back-validation_block",
        source: "1_CO_2_foreign_id_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "1_CO_3_pep-validation_block",
        source: "1_CO_3_pep",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "1_CO_4_passport-validation_block",
        source: "1_CO_4_passport",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      // MX --> validation block
      {
        id: "2_MX_1_national_id_back-validation_block",
        source: "2_MX_1_national_id_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "2_MX_2_foreign_id_back-validation_block",
        source: "2_MX_2_foreign_id_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "2_MX_3_passport-validation_block",
        source: "2_MX_3_passport",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      // BR --> validation block
      {
        id: "3_BR_1_national_id_back-validation_block",
        source: "3_BR_1_national_id_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "3_BR_2_drivers_license_back-validation_block",
        source: "3_BR_2_drivers_license_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "3_BR_3_passport-validation_block",
        source: "3_BR_3_passport",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      // CL --> validation block
      {
        id: "4_CL_1_national_id_back-validation_block",
        source: "4_CL_1_national_id_back",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      {
        id: "4_CL_2_passport-validation_block",
        source: "4_CL_2_passport",
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      // validation node.
      {
        id: "validation_block-ask_to_try_again_block",
        source: SEGMENT_VALIDATION_NODE_ID,
        target: SEGMENT_TRY_AGAIN_NODE_ID,
        data: {},
      },
      // retry block
      {
        id: "ask_to_try_again_block-1",
        source: SEGMENT_TRY_AGAIN_NODE_ID,
        target: SEGMENT_ROOT_NODE_ID,
        data: {},
      },
    ],
  };
};

export const getDocValidationWithFaceRecognitionSegment = (): Flow => {
  const documentValidationSegment = getDocValidationSegment();

  documentValidationSegment.nodes.push({
    id: "face_recognition_photo",
    data: {
      outgoingMessage:
        "¡Estamos a un paso de terminar tu validación!\n\nEnvía un foto con tu rostro para validar tu identidad.\n\n- Busca un lugar con buena iluminación.\n- Alinea la cámara que se pueda ver tu cara y hombros como en el ejemplo.",
      variableType: "image",
      file: "selfie",
      dimensions: {
        width: 0,
        height: 0,
      },
      strokeColor: "",
    },
    position: { x: 0, y: 0 },
    type: "simple",
  });

  const connectionsToRemove = [
    "1_CO_1_national_id_back",
    "1_CO_2_foreign_id_back",
    "1_CO_3_pep",
    "1_CO_4_passport",
    "2_MX_1_national_id_back",
    "2_MX_2_foreign_id_back",
    "2_MX_3_passport",
    "3_BR_1_national_id_back",
    "3_BR_2_drivers_license_back",
    "3_BR_3_passport",
    "4_CL_1_national_id_back",
    "4_CL_2_passport",
  ];

  documentValidationSegment.edges = documentValidationSegment.edges.filter(
    (edge) => !connectionsToRemove.includes(edge.source)
  );

  documentValidationSegment.edges = documentValidationSegment.edges.concat([
    // CO --> face recognition photo block
    {
      id: "1_CO_1_national_id_back-face_recognition_photo",
      source: "1_CO_1_national_id_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "1_CO_2_foreign_id_back-face_recognition_photo",
      source: "1_CO_2_foreign_id_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "1_CO_3_pep-face_recognition_photo",
      source: "1_CO_3_pep",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "1_CO_4_passport-face_recognition_photo",
      source: "1_CO_4_passport",
      target: "face_recognition_photo",
      data: {},
    },
    // MX --> face recognition photo block
    {
      id: "2_MX_1_national_id_back-face_recognition_photo",
      source: "2_MX_1_national_id_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "2_MX_2_foreign_id_back-face_recognition_photo",
      source: "2_MX_2_foreign_id_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "2_MX_3_passport-face_recognition_photo",
      source: "2_MX_3_passport",
      target: "face_recognition_photo",
      data: {},
    },
    // BR --> face recognition photo block
    {
      id: "3_BR_1_national_id_back-face_recognition_photo",
      source: "3_BR_1_national_id_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "3_BR_2_drivers_license_back-face_recognition_photo",
      source: "3_BR_2_drivers_license_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "3_BR_3_passport-face_recognition_photo",
      source: "3_BR_3_passport",
      target: "face_recognition_photo",
      data: {},
    },
    // CL --> face recognition photo block
    {
      id: "4_CL_1_national_id_back-face_recognition_photo",
      source: "4_CL_1_national_id_back",
      target: "face_recognition_photo",
      data: {},
    },
    {
      id: "4_CL_2_passport-face_recognition_photo",
      source: "4_CL_2_passport",
      target: "face_recognition_photo",
      data: {},
    },
    // face recognition photo --> validation block
    {
      id: "face_recognition_photo-validation_block",
      source: "face_recognition_photo",
      target: SEGMENT_VALIDATION_NODE_ID,
      data: {},
    },
  ]);

  return documentValidationSegment;
};

export const getEmailSegment = (): Flow => {
  return {
    nodes: [
      {
        id: SEGMENT_ROOT_NODE_ID,
        data: {
          outgoingMessage:
            "Vamos a validar tu correo electrónico ✉️\n¿Cuál es tu correo electrónico?",
          order: 1,
          incomingMessage: "Sí",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: SEGMENT_VALIDATION_NODE_ID,
        data: {
          outgoingMessage:
            "Hemos enviado un código de verificación al correo electrónico que ingresaste.\n\nPor favor ingresa los 6 dígitos del código",
          variableType: "string",
          conditionPaths: {
            success: "", // continue the block connected to the success edge.
            failure: SEGMENT_TRY_AGAIN_NODE_ID,
          },
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: SEGMENT_TRY_AGAIN_NODE_ID,
        data: {
          outgoingMessage:
            "El correo no pudo ser verificado, ¿Quieres reintentar?\n\n1) Sí\n2) No",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
    ],
    edges: [
      // Country multiple options
      {
        id: "1-email_validation_block",
        source: SEGMENT_ROOT_NODE_ID,
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      // validation node.
      {
        id: "email_validation_block-ask_to_try_again_block",
        source: SEGMENT_VALIDATION_NODE_ID,
        target: SEGMENT_TRY_AGAIN_NODE_ID,
        data: {},
      },
      // retry block
      {
        id: "ask_to_try_again_block-1",
        source: SEGMENT_TRY_AGAIN_NODE_ID,
        target: SEGMENT_ROOT_NODE_ID,
        data: {},
      },
    ],
  };
};

export const getPhoneSegment = (): Flow => {
  return {
    nodes: [
      {
        id: SEGMENT_ROOT_NODE_ID,
        data: {
          outgoingMessage:
            "Vamos a validar tu número de teléfono 📱\n¿Cuál es tu número de teléfono?\n\nEscríbelo en el formato: '+' + codigo del país + número. Ejemplo: +56983468234.",
          order: 1,
          incomingMessage: "Sí",
          variableType: "string",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: SEGMENT_VALIDATION_NODE_ID,
        data: {
          outgoingMessage:
            "Hemos enviado un SMS con el código de verificación al número que ingresaste.\n\nPor favor ingresa los 6 dígitos del código",
          variableType: "string",
          conditionPaths: {
            success: "", // continue the block connected to the success edge.
            failure: SEGMENT_TRY_AGAIN_NODE_ID,
          },
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
      {
        id: SEGMENT_TRY_AGAIN_NODE_ID,
        data: {
          outgoingMessage:
            "El teléfono no pudo ser verificado, ¿Quieres reintentar?\n\n1) Sí\n2) No",
          dimensions: {
            width: 0,
            height: 0,
          },
          strokeColor: "",
        },
        position: { x: 0, y: 0 },
        type: "simple",
      },
    ],
    edges: [
      // Country multiple options
      {
        id: "1-phone_validation_block",
        source: SEGMENT_ROOT_NODE_ID,
        target: SEGMENT_VALIDATION_NODE_ID,
        data: {},
      },
      // validation node.
      {
        id: "phone_validation_block-ask_to_try_again_block",
        source: SEGMENT_VALIDATION_NODE_ID,
        target: SEGMENT_TRY_AGAIN_NODE_ID,
        data: {},
      },
      // retry block
      {
        id: "ask_to_try_again_block-1",
        source: SEGMENT_TRY_AGAIN_NODE_ID,
        target: SEGMENT_ROOT_NODE_ID,
        data: {},
      },
    ],
  };
};
